import { IMenuStore, SectionId } from '@westondev/tableturn-core';
import { ITab } from './types';

export const MENU_SIDE_BAR_TABS_BY_BUCKET: Record<keyof IMenuStore, ITab[]> = {
  menuTypes: [
    { id: SectionId.BASIC },
    { id: SectionId.MORE_INFO },
    { id: SectionId.ASSOCIATION },
    { id: SectionId.TAXES },
  ],
  categories: [
    { id: SectionId.BASIC },
    { id: SectionId.MORE_INFO },
    { id: SectionId.ASSOCIATION },
    { id: SectionId.TAXES },
  ],
  subcategories: [
    { id: SectionId.BASIC },
    { id: SectionId.MORE_INFO },
    { id: SectionId.ASSOCIATION },
    { id: SectionId.TAXES },
  ],
  items: [
    { id: SectionId.BASIC },
    { id: SectionId.REGISTER },
    { id: SectionId.TAXES },
    { id: SectionId.GUEST_CHECK_DISPLAY },
    { id: SectionId.INVENTORY },
    { id: SectionId.MORE_INFO },
    { id: SectionId.INGREDIENTS },
    { id: SectionId.MODIFIERS },
    { id: SectionId.LINKED_MOD_ITEMS, hideOnMassUpdate: true },
    { id: SectionId.PREP_STATIONS },
    { id: SectionId.SUGGESTIVE_ORDERING },
    { id: SectionId.SPECIALS, hideOnMassUpdate: true },
    { id: SectionId.REPORTING_GROUPS },
  ],
  modifierGroups: [
    { id: SectionId.BASIC },
    { id: SectionId.REGISTER },
    { id: SectionId.MOD_ITEMS },
    { id: SectionId.ITEMS_AND_MOD_ITEMS },
  ],
  modifierItems: [
    { id: SectionId.BASIC },
    { id: SectionId.PRICING },
    { id: SectionId.INVENTORY },
    { id: SectionId.NESTED_MODS },
    { id: SectionId.MOD_GROUPS_AND_ITEMS },
  ],
  ingredients: [
    { id: SectionId.BASIC },
    { id: SectionId.INVENTORY },
    { id: SectionId.ASSOCIATION },
  ],
  combos: [
    { id: SectionId.BASIC },
    { id: SectionId.REGISTER },
    { id: SectionId.TAXES, hideOnMassUpdate: true },
    { id: SectionId.INVENTORY },
    { id: SectionId.MORE_INFO },
    { id: SectionId.ITEM_GROUPS },
    { id: SectionId.REPORTING_GROUPS },
  ],
  itemGroups: [{ id: SectionId.BASIC }, { id: SectionId.ASSOCIATION }],
  specials: [
    { id: SectionId.BASIC },
    { id: SectionId.MORE_INFO },
    { id: SectionId.AVAILABILITY },
    { id: SectionId.SPECIAL_SCHEME },
    { id: SectionId.ASSOCIATION },
  ],
  discounts: [
    { id: SectionId.BASIC },
    { id: SectionId.MORE_INFO },
    { id: SectionId.DISCOUNT_SCHEME },
  ],
  reportingGroups: [{ id: SectionId.BASIC }, { id: SectionId.ASSOCIATION }],
  hotButtons: [],
};
